import React from 'react'

const ModifPrixEditPage = () => {
  return (
      <></>
  )
}

export default ModifPrixEditPage
